import * as HoverCard from '@radix-ui/react-hover-card';
import type { ReactNode } from 'react';

export interface HoverCardProps {
  classNames?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  trigger: ReactNode;
  children: ReactNode;
  sideOffset?: number;
  disabled?: boolean;
  container?: HTMLDivElement | null;
  /** Skip the built-in white box styling; use when children render their own container (e.g. DetailCard). */
  unstyled?: boolean;
}

export default function HoverCardComponent({
  classNames = 'w-72',
  side = 'bottom',
  trigger,
  children,
  sideOffset = 12,
  disabled = false,
  container,
  unstyled = false,
}: HoverCardProps) {
  if (disabled) {
    return <>{trigger}</>;
  }

  return (
    <HoverCard.Root openDelay={400} closeDelay={100}>
      <HoverCard.Trigger asChild>{trigger}</HoverCard.Trigger>
      <HoverCard.Portal container={container ?? undefined}>
        <HoverCard.Content side={side} sideOffset={sideOffset} className="pointer-events-auto z-[150]">
          {unstyled ? children : <div className={`${classNames} rounded-sm bg-white p-4 shadow-lg`}>{children}</div>}
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  );
}
